import React, { useState } from "react";

function FurnitureRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How much does furniture removal cost?",
      content: `
The cost varies depending on the number of items, size, weight, and labor required. Contact us for a free, no-obligation estimate.
      `,
    },
    {
      title: "Do you offer same-day furniture removal?",
      content: `
      Yes! We provide same-day and next-day pickup options based on availability.
      `,
    },
    {
      title: "What types of furniture do you remove?",
      content: `
       We remove all types of furniture, including couches, mattresses, dressers, office desks, patio sets, and more.
      `,
    },
    {
      title: "Do you recycle or donate furniture?",
      content: `
         Absolutely! We prioritize donation and recycling whenever possible to reduce waste and support eco-friendly disposal.
        `,
    },
    {
      title: "Do I need to move the furniture outside?",
      content: `
           No, our team handles all the heavy lifting. Whether it’s inside your home, office, or storage unit, we’ll take care of it.
          `,
    },
    {
      title: "Which areas do you serve?",
      content: `
             We provide furniture removal services in San Jose, Sunnyvale, Palo Alto, Mountain View, and surrounding areas.
            `,
    },
    {
      title: "How do I schedule a pickup?",
      content: `
             Simply call or text us with your zip code to get a free estimate and book a pickup time that works for you!
            `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <i class="fa-solid fa-chevron-down"></i>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default FurnitureRemovalFAQs;
